import React from 'react';
import Header from '@/components/common/Header';
import Footer from '@/components/common/Footer';
import HeroSection from './HeroSection';
import SEO from '../../components/common/SEO';

const benefits = [
  {
    title: 'A Natural Source of Antioxidants',
    description:
      "Elixir honeys are packed with natural antioxidants, which help protect your body against free radicals and oxidative stress. These powerful compounds contribute to overall health and may play a role in preventing chronic diseases.",
    image: '/images/WELLNESS-1.webp',
    altText: 'Natural antioxidants in Elixir honey'
  },
  {
    title: 'Fuel Your Day the Natural Way',
    description:
      "Unlike refined sugars, this natural sweet elixir provides a sustained source of energy without the crash. It's a great option for the modern person to beat afternoon fatigue.",
    image: '/images/WELLNESS-2.webp',
    altText: 'Natural energy from Elixir honey'
  },
  {
    title: 'A Natural Ally for Your Immune System',
    description:
      "Certain types of honey, like Elixir's raw varieties, are full of antibacterial and antiviral properties. This natural power can support your body's ability to maintain a healthy immune system.",
    image: '/images/WELLNESS-3.webp',
    altText: 'Immune system support with Elixir honey'
  },
  {
    title: 'Supports Digestive Wellness',
    description:
      'Some studies suggest that raw honey may be beneficial for digestive health by promoting the growth of good gut bacteria and easing digestive discomfort.',
    image: '/images/WELLNESS-4.webp',
    altText: 'Digestive wellness with Elixir honey'
  },
];

function WellnessPage() {
  return (
    <div className="flex flex-col min-h-screen">
      <SEO
        title="Wellness"
        description="Discover the natural wellness benefits of Elixir honey. From antioxidants to immune support, explore how our premium Mediterranean honey varieties contribute to your health and well-being."
        keywords="
          honey wellness benefits,
          natural antioxidants,
          immune system support,
          digestive health honey,
          natural energy source,
          honey health properties,
          Mediterranean honey benefits,
          raw honey benefits
        "
      />
      <Header />
      <HeroSection />

      <main className="py-12 px-4 max-w-5xl mx-auto space-y-12">
        {benefits.map((item, index) => (
          <div
            key={index}
            className={`flex flex-col md:flex-row ${
              index % 2 !== 0 ? 'md:flex-row-reverse' : ''
            } items-center gap-6`}
          >
            {/* Wellness Image */}
            <div className="w-full md:w-1/2 aspect-[16/9]">
              <img
                src={item.image}
                alt={item.altText}
                className="w-full h-full object-cover rounded-md"
              />
            </div>

            {/* Text Content */}
            <div className="w-full md:w-1/2">
              <h2 className="text-xl font-semibold text-gray-900 mb-2">{item.title}</h2>
              <p className="text-gray-700">{item.description}</p>
            </div>
          </div>
        ))}

        {/* Final Summary Section */}
        <div className="text-center max-w-3xl mx-auto pt-12 border-t border-gray-200 mt-12">
          <h3 className="text-xl font-bold mb-2">Why Choose Elixir for Your Well-being?</h3>
          <p className="text-gray-600">
            From daily energy support to antioxidant-rich immune care, Elixir's natural honey
            varieties offer a wellness solution that blends nature and science beautifully.
          </p>
        </div>

        {/* Disclaimer Note */}
        <div className="text-center text-xs text-gray-500 mt-8 border-t pt-4 border-gray-200">
          <p>
            Please Note: Elixir honeys are natural supplements and not intended to diagnose,
            treat, cure, or prevent any disease. Always consult a healthcare professional for
            medical advice.
          </p>
        </div>
      </main>

      <Footer />
    </div>
  );
}

export default WellnessPage;
